import {
  TextCaption,
  TextCaptionHighlight,
} from '@ferreri/prever-component-lib';
import { MARITAL_STATUS_MAP } from '../../../utils/maritalStatusMap';
import { ExtendedGroupType } from './rules.types';

type SiblingLabelProps = {
  sibling: ExtendedGroupType;
  index: number;
};

export const SiblingLabel = (props: SiblingLabelProps) => {
  const isFinancial = props.sibling.is_financial_dependent;

  const suffix = isFinancial ? '*' : '';

  const rule = formatDependentRuleData(props.sibling);
  const description = `${props.sibling.kinship?.name} ${rule}${suffix}`;

  const Label = props.index === 0 ? TextCaptionHighlight : TextCaption;

  return <Label key={props.index}>{description}</Label>;
};

export const formatDependentRuleData = (item) => {
  const result = [];
  if (item?.marital_status) {
    result.push(`${MARITAL_STATUS_MAP[item.marital_status]?.toLowerCase()}`);
  }

  if (item?.min_age && item?.max_age) {
    return `entre ${item.min_age} e ${item.max_age} anos`;
  }

  if (item?.min_age && !item?.max_age) {
    result.push(`a partir de ${item.min_age} anos`);
  }
  if (!item?.min_age && item?.max_age) {
    result.push(`até ${item.max_age} anos`);
  }

  const value = result.join(' ');

  return value;
};
